import { Avatar } from '@mui/material';
import { useEffect, useState } from 'react';
import { downloadProfilePhoto } from '@/api/auth';
import { useAuth } from '@/auth/useAuth';

interface CurrentUserAvatarProps {
  size?: number;
}

function initials(name: string | undefined): string {
  const parts = name?.trim().split(/\s+/).filter(Boolean) ?? [];
  const letters = parts.slice(0, 2).map((part) => part[0]?.toUpperCase()).join('');

  return letters || '?';
}

export function CurrentUserAvatar({ size = 36 }: CurrentUserAvatarProps) {
  const { user } = useAuth();
  const [objectUrl, setObjectUrl] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    let nextObjectUrl: string | null = null;

    setObjectUrl(null);

    if (!user?.profile_photo_storage_key) {
      return () => {
        cancelled = true;
      };
    }

    downloadProfilePhoto()
      .then((blob) => {
        if (cancelled) return;

        nextObjectUrl = URL.createObjectURL(blob);
        setObjectUrl(nextObjectUrl);
      })
      .catch(() => {
        if (!cancelled) setObjectUrl(null);
      });

    return () => {
      cancelled = true;
      if (nextObjectUrl) URL.revokeObjectURL(nextObjectUrl);
    };
  }, [user?.profile_photo_storage_key]);

  return (
    <Avatar
      src={objectUrl ?? undefined}
      alt={user?.name ?? 'User profile'}
      sx={{ width: size, height: size, fontSize: `${Math.max(0.85, size / 42)}rem`, fontWeight: 700 }}
    >
      {initials(user?.name)}
    </Avatar>
  );
}
